import {
  spanLongTermAmpacityPlotDef,
  spanLastAmpacityAARPlotDef,
  spanLastAmpacityDLRPlotDef,
  spanBelowNominalAmpacityTablePlotDef,
  spanConductorTemperaturePlotDef,
  spanLastConductorTemperaturePlotDef,
} from "./defs"

export const spanOverviewTabPlotDefs = [
  spanLongTermAmpacityPlotDef,
  spanLastAmpacityAARPlotDef,
  spanLastAmpacityDLRPlotDef,
  spanBelowNominalAmpacityTablePlotDef,
  spanConductorTemperaturePlotDef,
  spanLastConductorTemperaturePlotDef,
]
